module.exports = __webpack_public_path__ + "static/media/transactions.b2f55162.svg";